import { render, staticRenderFns } from "./SpecialOfferBadge.vue?vue&type=template&id=24b12c18&scoped=true&"
import script from "./SpecialOfferBadge.vue?vue&type=script&lang=js&"
export * from "./SpecialOfferBadge.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOfferBadge.vue?vue&type=style&index=0&id=24b12c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b12c18",
  null
  
)

export default component.exports